import { Link } from 'react-router-dom';
import { manhwas } from '@/mocks/manhwas';

interface CategoryOverviewProps {
  selectedCategory: string;
  onCategoryChange: (slug: string) => void;
}

const displayCategories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'historical', name: '古风', icon: 'ri-landscape-line' },
  { slug: 'urban', name: '都市', icon: 'ri-building-line' },
];

export default function CategoryOverview({ selectedCategory, onCategoryChange }: CategoryOverviewProps) {
  const filteredManhwas = selectedCategory === 'all'
    ? manhwas.slice(0, 8)
    : manhwas.filter((m) => m.categorySlug === selectedCategory).slice(0, 8);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6" aria-labelledby="category-heading">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <h2 id="category-heading" className="text-xl md:text-2xl font-heading text-foreground-950">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型探索你喜欢的韩漫</p>
        </div>

        <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2" role="tablist" aria-label="漫画分类">
          {displayCategories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => onCategoryChange(cat.slug)}
              role="tab"
              aria-selected={selectedCategory === cat.slug}
              className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                selectedCategory === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              <i className={cat.icon}></i>
              {cat.name}
            </button>
          ))}
        </div>

        {filteredManhwas.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {filteredManhwas.map((m) => (
              <Link
                key={m.id}
                to={`/manhwa/${m.id}`}
                className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer"
              >
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={m.coverImage}
                    alt={m.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    title={`${m.title} - 好看韩国漫画`}
                  />
                </div>
                <div className="p-3">
                  <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
                    {m.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">{m.category} · {m.totalChapters}话</p>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="text-center py-16 text-foreground-400">
            <i className="ri-inbox-line text-4xl block mb-3"></i>
            <p className="text-sm">该分类暂无漫画</p>
          </div>
        )}

        <div className="text-center mt-8">
          <Link
            to={`/category/${selectedCategory}`}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-primary-300 text-primary-500 text-sm font-medium hover:bg-primary-50 transition-all duration-200 whitespace-nowrap"
          >
            查看全部 {selectedCategory !== 'all' ? displayCategories.find(c => c.slug === selectedCategory)?.name : ''} 漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}